/*** IMPORTS FROM imports-loader ***/
var angular = require("angular");

module.exports = "\t<div ng-init=\"app.settings.container = false;\" class=\"md-navbar navbar blue md-whiteframe-z1\" data-ng-include=\" 'tpl/blocks/material.header.html' \" >\n\t</div>\n\t<div layout=\"row\">\n\t  <!-- menu -->\n\t  <div flex class=\"bg-white md-whiteframe-z0 md-aside md-content hidden-xs\" data-ng-include=\" 'tpl/blocks/material.aside.html' \">\n\t  </div>\n\t  <!-- / menu -->\n\n\t  <!-- view -->\n\t  <div flex layout=\"column\">\n\t  \t<div ui-butterbar></div>\n    \t<a href class=\"off-screen-toggle hide\" ui-toggle-class=\"off-screen\" data-target=\".md-aside\" ></a>\n\t  \t<div class=\"md-content\" ui-view></div>\n\t  </div>\n\t  <!-- / view -->\n\t</div>\n"



//////////////////
// WEBPACK FOOTER
// ./~/imports-loader?angular!./src/app/blocks/material.layout.html
// module id = 153
// module chunks = 1